var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"register_to_find_job_link"}},[_c('router-link',{staticClass:" font-koho text-mainColor text-base sm:text-xs lg:text-sm",attrs:{"to":"/jobseeker_register"}},[_vm._v("REGISTER TO FIND A JOB")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }